export const clientDevelopment = {
    commonMinHeight: 95,
};
